import { createStore } from "vuex";
import auth from "./modules/auth";
import user from "./modules/user";
import claims from "./modules/claims";
import benefits from "./modules/benefits";
import funeral from "./modules/funeral";
import injury from "./modules/injury";
import sickness from "./modules/sickness";
import retirement from "./modules/retirement";
import maternity from "./modules/maternity";
import maternityExt from "./modules/maternityExt";
import unemployment from "./modules/unemployment";
import sicknessExt from "./modules/sicknessExt";
import miscData from "./modules/miscData";
import cards from "./modules/cards";

// Create a new store instance.
const store = createStore({
  modules: {
    auth,
    user,
    claims,
    benefits,
    funeral,
    injury,
    sickness,
    retirement,
    miscData,
    cards,
    maternity,
    maternityExt,
    sicknessExt,
    unemployment,
  },
});

export default store;
